import { variables } from "../../variables";

export default {
    actions: {
        async _createSeller(context, body){
            return await context.rootGetters.api.post(`${variables.serverUrl}/api/v1/sellers`, body);
        },
        async _updateSeller(context, { body, sellerId }){
            return await context.rootGetters.api.put(`${variables.serverUrl}/api/v1/sellers/${sellerId}`, body);
        },
        async _deleteSeller(context, { sellerId }){
            return await context.rootGetters.api.delete(`${variables.serverUrl}/api/v1/sellers/${sellerId}`);
        },
        async _getSellers(context, { pageSize, pageNumber, name }){
            return await context.rootGetters.api.get(`${variables.serverUrl}/api/v1/sellers?pageSize=${pageSize}&pageNumber=${pageNumber}&name=${name}`);
        }
    }
}